<template>
  <div>
    <v-container fluid>
      <v-skeleton-loader
        :loading="!flagNav"
        transition="scale-transition"
        max-height="64"
        type="table-heading"
      >
        <v-toolbar :image="SubNavbarBackGround" dark class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">Intent Session Detail</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>

      <v-card class="card2" style="margin-top: 1rem">
        <v-container class="px-6 py-6">
          <v-row>
            <v-col cols="12" sm="12" md="5">
              <v-text-field
                id="intentsessionname-intentsessiondetail"
                variant="outlined"
                density="comfortable"
                label="Intent Session Name*"
                v-model="Request.Name"
                :rules="[rules.required]"
                hide-details="auto"
                color="primary"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="2">
              <v-text-field
                id="score-intentsessiondetail"
                variant="outlined"
                density="comfortable"
                label="Score"
                v-model="Request.Score"
                @keypress="isNumberpositive($event)"
                hide-details="auto"
                color="primary"
              >
                <template v-slot:append-inner>
                  <v-tooltip location="top" max-width="300px">
                    <template v-slot:activator="{ props }">
                      <v-icon v-bind="props" size="small" color="grey-darken-1">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{ $t("_InfoScore") }}</span>
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="2">
              <v-checkbox
                id="usememory-intentsessiondetail"
                v-model="Request.UseMemory"
                label="Use memory"
                color="primary"
                hide-details
                density="comfortable"
              >
                <template v-slot:label>
                  <v-tooltip location="top" max-width="40vw">
                    <template v-slot:activator="{ props }">
                      <label v-bind="props" class="text-body-2"
                        >Use memory</label
                      >
                    </template>
                    <span>Use memory</span>
                  </v-tooltip>
                </template>
              </v-checkbox>
            </v-col>
            <v-col cols="12" sm="12" md="12" class="mt-4">
              <v-textarea
                id="prompt-intentsessiondetail"
                variant="outlined"
                rows="7"
                v-model="Request.PromptSession"
                label="Prompt Session"
                placeholder="Enter the Prompt..."
                hide-details="auto"
                color="primary"
              ></v-textarea>
            </v-col>
          </v-row>

          <v-expansion-panels
            v-model="panel"
            multiple
            class="mt-6"
            variant="accordion"
          >
            <!-- Intent Panel -->
            <v-expansion-panel class="modern-panel">
              <v-expansion-panel-title
                id="intent-intentsessiondetail"
                class="panel-header"
              >
                <template v-slot:default="{ expanded }">
                  <v-row no-gutters>
                    <v-col cols="4" class="d-flex justify-start">
                      <v-icon
                        :class="expanded ? 'rotate-180' : ''"
                        class="transition-transform"
                      >
                        mdi-chevron-down
                      </v-icon>
                      <span class="header-text ml-2">Intent</span>
                    </v-col>
                  </v-row>
                </template>
              </v-expansion-panel-title>

              <v-expansion-panel-text class="panel-content">
                <v-row class="mb-4">
                  <v-col cols="12" class="d-flex justify-end align-center">
                    <v-btn
                      id="download-template-intentsessiondetail"
                      variant="text"
                      color="primary"
                      @click="downloadTemplate()"
                      class="mr-4"
                    >
                      <v-icon start>mdi-download</v-icon>
                      Template
                    </v-btn>
                    <DragDropFile
                      id="uploadfile-intentsessiondetail"
                      :dialog="true"
                      :DragDrop="false"
                      :ShowListFile="false"
                      accept=".xlsx"
                      @filesUploaded="processUpload($event)"
                      :allowType="[
                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                      ]"
                      class="UploadFile"
                    />
                  </v-col>
                </v-row>

                <v-card variant="outlined" class="intent-container">
                  <div
                    v-for="(item, index) in Intent"
                    :key="index"
                    class="intent-item"
                  >
                    <div class="intent-number">{{ index + 1 }}</div>
                    <v-textarea
                      :id="'textarea-intent-intentsessiondetail-' + index"
                      variant="plain"
                      class="intent-textarea"
                      v-model="item.text"
                      placeholder="Enter the message intent..."
                      @keypress="isEnter($event, index)"
                      @keypress.enter="newLineEnter(index)"
                      ref="textareas"
                      @paste="onPaste(index, $event)"
                      @keyup.delete="CheckDeleteIntent(index, item.text)"
                      rows="2"
                      auto-grow
                      hide-details
                    ></v-textarea>
                    <v-btn
                      :id="'button-delete-intentsessiondetail-' + index"
                      v-show="index + 1 < Intent.length"
                      @click="Intent.splice(index, 1)"
                      icon
                      size="small"
                      variant="text"
                      color="error"
                      class="delete-intent-btn"
                    >
                      <v-tooltip location="top" open-delay="500">
                        <template v-slot:activator="{ props }">
                          <v-icon v-bind="props">mdi-delete</v-icon>
                        </template>
                        <span>Delete</span>
                      </v-tooltip>
                    </v-btn>
                  </div>
                </v-card>
              </v-expansion-panel-text>
            </v-expansion-panel>

            <!-- Action Panel -->
            <v-expansion-panel class="modern-panel">
              <v-expansion-panel-title
                id="action-intentsessiondetail"
                class="panel-header"
              >
                <template v-slot:default="{ expanded }">
                  <v-row no-gutters>
                    <v-col cols="4" class="d-flex justify-start">
                      <v-icon
                        :class="expanded ? 'rotate-180' : ''"
                        class="transition-transform"
                      >
                        mdi-chevron-down
                      </v-icon>
                      <span class="header-text ml-2">Action</span>
                    </v-col>
                  </v-row>
                </template>
              </v-expansion-panel-title>

              <v-expansion-panel-text class="panel-content">
                <div class="action-container">
                  <div
                    v-for="(items, indexs) in Request.IntentActions.filter(
                      (e) => e.activeFlag == true
                    )"
                    :key="indexs + 'a'"
                    class="action-section mb-8"
                  >
                    <!-- Action Header -->
                    <div class="action-header">
                      <div
                        class="action-type-badge"
                        :class="
                          items.isActionAnswer
                            ? 'action-answer'
                            : 'action-parallel'
                        "
                      >
                        <v-icon
                          :color="items.isActionAnswer ? 'white' : 'primary'"
                          class="mr-2"
                          size="small"
                        >
                          {{
                            items.isActionAnswer
                              ? "mdi-check-circle"
                              : "mdi-cog"
                          }}
                        </v-icon>
                        <span class="action-type-text">
                          {{
                            items.isActionAnswer
                              ? "Action Answer"
                              : "Action Parallel"
                          }}
                        </span>
                      </div>

                      <v-btn
                        v-show="!items.isActionAnswer"
                        :id="'DeleteAction-intentsessiondetail' + indexs"
                        @click="DeleteAction(items, indexs)"
                        icon
                        size="small"
                        variant="text"
                        color="error"
                        class="delete-action-btn"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </div>

                    <v-divider class="mb-6"></v-divider>

                    <!-- Action Type Selection -->
                    <v-row class="mb-4">
                      <v-col md="9" sm="12">
                        <v-autocomplete
                          :id="'actiontype-intentsessiondetail-' + indexs"
                          variant="outlined"
                          density="comfortable"
                          label="Action type*"
                          :items="
                            items.isActionAnswer
                              ? DDActionType
                              : DDActionType.filter(
                                  (e) => e.value == 'AT' || e.value == 'CA'
                                )
                          "
                          item-title="name"
                          item-value="value"
                          clearable
                          v-model="items.actionType"
                          @update:model-value="ChangeAction(items)"
                          hide-details="auto"
                          color="primary"
                        >
                          <template v-slot:item="{ props, item }">
                            <v-list-item v-bind="props">
                              <template v-slot:append v-if="item.raw.chip">
                                <v-chip 
                                  color="success" 
                                  variant="outlined" 
                                  size="x-small"
                                  class="ml-2"
                                >
                                  {{ item.raw.chip }}
                                </v-chip>
                              </template>
                            </v-list-item>
                          </template>
                          <template v-slot:append-inner>
                            <v-tooltip location="top">
                              <template v-slot:activator="{ props }">
                                <v-icon
                                  v-bind="props"
                                  size="small"
                                  color="grey-darken-1"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>Action type information</span>
                            </v-tooltip>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col
                        md="3"
                        sm="12"
                        v-if="
                          items.actionType != 'MR' &&
                          items.actionType != 'NR' &&
                          items.actionType != ''
                        "
                      >
                        <v-checkbox
                          :id="'mergeprompt-intentsessiondetail-' + indexs"
                          v-model="items.isMergePrompt"
                          label="Merge prompt"
                          color="primary"
                          hide-details
                          density="comfortable"
                        >
                          <template v-slot:label>
                            <v-tooltip location="top" max-width="40vw">
                              <template v-slot:activator="{ props }">
                                <label v-bind="props" class="text-body-2"
                                  >Merge prompt</label
                                >
                              </template>
                              <span>Merge prompt</span>
                            </v-tooltip>
                          </template>
                        </v-checkbox>
                      </v-col>
                    </v-row>

                    <!-- Vector Type Content -->
                    <v-expand-transition>
                      <div v-show="items.actionType == 'VT'">
                        <v-row class="mb-4">
                          <v-col cols="6">
                            <!-- App Knowledge Center (D4): โหมด Center เลือก chunk ของเอกสารไม่ได้ -->
                            <v-alert v-if="kccCenterMode" type="warning" variant="tonal" density="compact"
                              class="mb-3 text-caption">
                              {{ $t("kccVtUnavailable") }}
                            </v-alert>
                            <v-autocomplete
                              :id="'vectorname-intentsessiondetail-' + indexs"
                              label="Vector Name*"
                              :items="DDVector"
                              item-title="name"
                              item-value="name"
                              :disabled="kccCenterMode"
                              clearable
                              variant="outlined"
                              v-model="VectorName"
                              @update:model-value="GetByVector()"
                              density="comfortable"
                              hide-details="auto"
                              color="primary"
                            >
                              <template v-slot:append-inner>
                                <v-tooltip location="top">
                                  <template v-slot:activator="{ props }">
                                    <v-icon
                                      v-bind="props"
                                      size="small"
                                      color="grey-darken-1"
                                    >
                                      mdi-information-outline
                                    </v-icon>
                                  </template>
                                  <span>{{ $t("_InfoProvider") }}</span>
                                </v-tooltip>
                              </template>
                            </v-autocomplete>
                          </v-col>
                        </v-row>

                        <v-data-table
                          v-show="ShowTable"
                          :items-per-page="itemsPerPage"
                          :server-items-length="searchTotalTable"
                          v-model:options="options"
                          :items="dataTable"
                          :headers="headers"
                          :loading="loadingTable"
                          loading-text="Loading..."
                          fixed-header
                          class="elevation-1 vector-table mb-4"
                          density="comfortable"
                        >
                          <template v-slot:item="{ item }">
                            <tr>
                              <td class="text-center pa-2">
                                <v-checkbox
                                  :id="
                                    'selectvector-intentsessiondetail-' + indexs
                                  "
                                  v-model="item.selected"
                                  @change="
                                    SelectVector(
                                      items,
                                      item.selected,
                                      item.id,
                                      item.textORG
                                    )
                                  "
                                  hide-details
                                  density="compact"
                                  color="primary"
                                ></v-checkbox>
                              </td>
                              <td class="pa-2">
                                <div class="text-container">
                                  <span
                                    :class="[
                                      item.show
                                        ? 'text-content-show'
                                        : 'text-content',
                                    ]"
                                    v-html="formatText(item.textORG)"
                                  ></span>
                                </div>
                              </td>
                              <td class="pa-2">
                                <div class="text-container">
                                  <span
                                    :class="[
                                      item.show
                                        ? 'text-content-show'
                                        : 'text-content',
                                    ]"
                                    v-html="formatText(item.textEN)"
                                  ></span>
                                  <v-btn
                                    :id="
                                      'itemshow-intentsessiondetail-' + indexs
                                    "
                                    @click="item.show = !item.show"
                                    icon
                                    size="small"
                                    variant="text"
                                    class="ml-2"
                                  >
                                    <v-icon>{{
                                      item.show
                                        ? "mdi-chevron-up"
                                        : "mdi-chevron-down"
                                    }}</v-icon>
                                  </v-btn>
                                </div>
                              </td>
                            </tr>
                          </template>
                        </v-data-table>

                        <div
                          class="selected-vectors mb-4"
                          v-if="
                            items.vectorDetail && items.vectorDetail.length > 0
                          "
                        >
                          <div class="mb-2">
                            <span class="text-subtitle-2 font-weight-medium"
                              >Selected Vectors:</span
                            >
                          </div>
                          <div class="d-flex flex-wrap ga-2">
                            <v-chip
                              v-for="(item3, vectorIndex) in items.vectorDetail"
                              :key="vectorIndex + '_TextORG'"
                              closable
                              @click:close="
                                DeleteVectorByBtn(items, item3.tblVector)
                              "
                              color="primary"
                              variant="elevated"
                              size="small"
                              class="selected-vector-chip"
                            >
                              <v-tooltip location="top" open-delay="500">
                                <template v-slot:activator="{ props }">
                                  <span v-bind="props">{{
                                    item3.textORG
                                  }}</span>
                                </template>
                                <span>{{ item3.textORG }}</span>
                              </v-tooltip>
                            </v-chip>
                          </div>
                        </div>

                        <v-textarea
                          :id="'textarea-prompt-intentsessiondetail-' + indexs"
                          variant="outlined"
                          v-model="items.prompt"
                          label="Prompt"
                          placeholder="Enter the Prompt..."
                          hide-details="auto"
                          color="primary"
                        ></v-textarea>
                      </div>
                    </v-expand-transition>

                    <!-- Text Response Content -->
                    <v-expand-transition>
                      <div v-show="items.actionType == 'TR'">
                        <v-textarea
                          :id="'textarea-message-intentsessiondetail-' + indexs"
                          variant="outlined"
                          v-model="items.textResponse"
                          label="Message"
                          placeholder="Enter the message..."
                          hide-details="auto"
                          color="primary"
                        ></v-textarea>
                      </div>
                    </v-expand-transition>

                    <!-- Model Routing Content -->
                    <v-expand-transition>
                      <div v-show="items.actionType == 'MR'">
                        <v-row>
                          <v-col cols="6">
                            <v-autocomplete
                              id="choose-model-modelrouting-intentsessiondetail"
                              ref="model"
                              label="Next Routing*"
                              :items="listDDModelDisplayName"
                              :item-title="getItemModelNameText"
                              item-value="modelDisplayID"
                              clearable
                              variant="outlined"
                              v-model="items.modelDisplayRouting"
                              density="comfortable"
                              hide-details="auto"
                              color="primary"
                            >
                              <template v-slot:append-inner>
                                <v-tooltip location="top">
                                  <template v-slot:activator="{ props }">
                                    <v-icon
                                      v-bind="props"
                                      size="small"
                                      color="grey-darken-1"
                                    >
                                      mdi-information-outline
                                    </v-icon>
                                  </template>
                                  <span>{{ $t("_InfoProvider") }}</span>
                                </v-tooltip>
                              </template>
                            </v-autocomplete>
                          </v-col>
                        </v-row>
                      </div>
                    </v-expand-transition>

                    <!-- Next Routing Content -->
                    <v-expand-transition>
                      <div v-show="items.actionType == 'NR'">
                        <v-row>
                          <v-col cols="6">
                            <v-autocomplete
                              :id="'nextrouting-intentsessiondetail-' + indexs"
                              ref="model"
                              label="Next Routing*"
                              :items="listDDIntentGroup"
                              item-title="name"
                              item-value="id"
                              clearable
                              variant="outlined"
                              v-model="items.nextRouting"
                              density="comfortable"
                              hide-details="auto"
                              color="primary"
                            >
                              <template v-slot:append-inner>
                                <v-tooltip location="top">
                                  <template v-slot:activator="{ props }">
                                    <v-icon
                                      v-bind="props"
                                      size="small"
                                      color="grey-darken-1"
                                    >
                                      mdi-information-outline
                                    </v-icon>
                                  </template>
                                  <span>{{ $t("_InfoProvider") }}</span>
                                </v-tooltip>
                              </template>
                            </v-autocomplete>
                          </v-col>
                        </v-row>
                      </div>
                    </v-expand-transition>

                    <!-- Contact Agent Content -->
                    <v-expand-transition>
                      <div v-show="items.actionType == 'CA'">
                        <!-- Bot Disable Time Field -->
                        <div class="time-field-container mb-4">
                          <v-text-field
                            id="botDisableTime-intentsessiondetail"
                            variant="outlined"
                            density="comfortable"
                            label="Bot Disable Time (minutes)"
                            v-model="items.botDisableTime"
                            @keypress="isNumberpositive($event)"
                            placeholder="Enter time in minutes"
                            hide-details="auto"
                            class="time-input"
                            type="number"
                            min="0"
                          >
                            <template v-slot:append-outer>
                              <v-tooltip location="top" max-width="300px">
                                <template v-slot:activator="{ props }">
                                  <v-icon
                                    size="small"
                                    color="grey-darken-1"
                                    class="info-icon"
                                    v-bind="props"
                                  >
                                    mdi-information-outline
                                  </v-icon>
                                </template>
                                <span
                                  >Specify the duration for bot deactivation (in
                                  minutes) when transferring to an agent. If
                                  left blank, the bot will remain active.</span
                                >
                              </v-tooltip>
                            </template>
                          </v-text-field>
                        </div>

                        <!-- Contact Agent Message -->
                        <v-textarea
                          id="prompt-contactAgent-intentsessiondetail"
                          variant="outlined"
                          v-model="items.contactAgent"
                          label="Contact Agent Message"
                          placeholder="Enter the message..."
                          hide-details="auto"
                          color="primary"
                        ></v-textarea>
                      </div>
                    </v-expand-transition>

                    <!-- API Trigger Content -->
                    <v-expand-transition>
                      <div v-show="items.actionType == 'AT'">
                        <!-- API Method and Endpoint -->
                        <v-row class="mb-4">
                          <v-col cols="2">
                            <v-autocomplete
                              :id="'method-intentsessiondetail-' + indexs"
                              ref="model"
                              label="Method*"
                              :items="DDMethod"
                              clearable
                              variant="outlined"
                              v-model="items.method"
                              density="comfortable"
                              hide-details="auto"
                              color="primary"
                            />
                          </v-col>
                          <v-col cols="10">
                            <v-text-field
                              :id="'APIendpoint-intentsessiondetail-' + indexs"
                              label="API Endpoint*"
                              v-model="items.apiEndpoint"
                              variant="outlined"
                              density="comfortable"
                              hide-details="auto"
                              color="primary"
                            ></v-text-field>
                          </v-col>
                        </v-row>

                        <!-- Headers Section -->
                        <div class="mb-6">
                          <div class="section-title-simple mb-3">
                            <v-icon color="primary" class="mr-2"
                              >mdi-web</v-icon
                            >
                            <span class="text-h6">Headers</span>
                          </div>

                          <div
                            v-for="(
                              header, headerIndex
                            ) in items.listHeadersAPITrigger"
                            :key="headerIndex + 'header'"
                            class="mb-3"
                          >
                            <v-row>
                              <v-col cols="4">
                                <v-text-field
                                  :id="'key-intentsessiondetail-' + headerIndex"
                                  label="Key"
                                  v-model="header.key"
                                  variant="outlined"
                                  density="comfortable"
                                  hide-details
                                  color="primary"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="7">
                                <v-text-field
                                  :id="
                                    'value-intentsessiondetail-' + headerIndex
                                  "
                                  label="Value"
                                  v-model="header.value"
                                  variant="outlined"
                                  density="comfortable"
                                  hide-details
                                  color="primary"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="1" class="d-flex align-center">
                                <v-btn
                                  :id="
                                    'DeleteHeader-intentsessiondetail-' +
                                    headerIndex
                                  "
                                  @click="
                                    DeleteHeader(items, indexs, headerIndex)
                                  "
                                  icon
                                  size="small"
                                  variant="text"
                                  color="error"
                                >
                                  <v-icon>mdi-delete-circle</v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </div>

                          <v-btn
                            :id="'AddColumn-intentsessiondetail-' + indexs"
                            @click="AddHeader(items)"
                            variant="outlined"
                            color="primary"
                            size="small"
                            class="mt-2"
                          >
                            <v-icon start>mdi-plus-circle</v-icon>
                            Add Header
                          </v-btn>
                        </div>

                        <!-- JSON Request Section -->
                        <div class="mb-6">
                          <div class="section-title-simple mb-3">
                            <v-icon color="primary" class="mr-2"
                              >mdi-code-json</v-icon
                            >
                            <span class="text-h6">JSON Request</span>
                          </div>

                          <v-row class="mb-3">
                            <v-col cols="6">
                              <v-autocomplete
                                :id="'modeljason-intentsessiondetail-' + indexs"
                                ref="model"
                                label="Model JSON*"
                                :items="listDDModelDisplayName"
                                :item-title="getItemModelNameText"
                                item-value="modelDisplayID"
                                clearable
                                variant="outlined"
                                density="comfortable"
                                v-model="items.modelDisplayRouting"
                                hide-details="auto"
                                color="primary"
                              >
                                <template v-slot:append-inner>
                                  <v-tooltip location="top">
                                    <template v-slot:activator="{ props }">
                                      <v-icon
                                        v-bind="props"
                                        size="small"
                                        color="grey-darken-1"
                                      >
                                        mdi-information-outline
                                      </v-icon>
                                    </template>
                                    <span>{{ $t("_InfoProvider") }}</span>
                                  </v-tooltip>
                                </template>
                              </v-autocomplete>
                            </v-col>
                          </v-row>

                          <div class="json-editor-container">
                            <div class="json-variables">
                              <div class="variables-header">
                                <span class="text-subtitle-2"
                                  >Available Variables (Click or Drag to
                                  insert)</span
                                >
                              </div>
                              <div class="variables-grid">
                                <v-chip
                                  :id="
                                    'JSONValidate-transectionID-intentsessiondetail' +
                                    indexs
                                  "
                                  class="variable-chip"
                                  @dragstart="
                                    onDragStart($event, '{transactionID}')
                                  "
                                  @click="
                                    insertVariable('{transactionID}', indexs)
                                  "
                                  draggable="true"
                                  color="primary"
                                  variant="outlined"
                                  size="small"
                                >
                                  <v-icon start size="small">mdi-drag</v-icon>
                                  Transaction ID
                                </v-chip>
                                <v-chip
                                  :id="
                                    'JSONValidate-channel-intentsessiondetail' +
                                    indexs
                                  "
                                  class="variable-chip"
                                  @dragstart="onDragStart($event, '{channel}')"
                                  @click="insertVariable('{channel}', indexs)"
                                  draggable="true"
                                  color="primary"
                                  variant="outlined"
                                  size="small"
                                >
                                  <v-icon start size="small">mdi-drag</v-icon>
                                  Channel
                                </v-chip>
                                <v-chip
                                  :id="
                                    'JSONValidate-channelID-intentsessiondetail' +
                                    indexs
                                  "
                                  class="variable-chip"
                                  @dragstart="
                                    onDragStart($event, '{channelID}')
                                  "
                                  @click="insertVariable('{channelID}', indexs)"
                                  draggable="true"
                                  color="primary"
                                  variant="outlined"
                                  size="small"
                                >
                                  <v-icon start size="small">mdi-drag</v-icon>
                                  Channel ID
                                </v-chip>
                                <v-chip
                                  :id="
                                    'JSONValidate-userchannel-intentsessiondetail' +
                                    indexs
                                  "
                                  class="variable-chip"
                                  @dragstart="
                                    onDragStart($event, '{userChannel}')
                                  "
                                  @click="
                                    insertVariable('{userChannel}', indexs)
                                  "
                                  draggable="true"
                                  color="primary"
                                  variant="outlined"
                                  size="small"
                                >
                                  <v-icon start size="small">mdi-drag</v-icon>
                                  User Channel
                                </v-chip>
                                <v-chip
                                  :id="
                                    'JSONValidate-sessionID-intentsessiondetail' +
                                    indexs
                                  "
                                  class="variable-chip"
                                  @dragstart="
                                    onDragStart($event, '{sessionID}')
                                  "
                                  @click="insertVariable('{sessionID}', indexs)"
                                  draggable="true"
                                  color="primary"
                                  variant="outlined"
                                  size="small"
                                >
                                  <v-icon start size="small">mdi-drag</v-icon>
                                  Session ID
                                </v-chip>
                              </div>
                            </div>
                            <prism-editor
                              :id="'codeEditor-' + indexs"
                              class="modern-editor"
                              v-model="items.jsonValidate"
                              :highlight="highlighter"
                              @drop="onDrop($event)"
                              @dragover="onDragOver($event)"
                              @dragleave="onDragLeave($event)"
                              :line-numbers="true"
                              :autoStyleLineNumbers="true"
                              :ignoreTabKey="true"
                            ></prism-editor>
                          </div>
                        </div>

                        <!-- Validation Section -->
                        <div class="mb-6">
                          <div class="section-title-simple mb-3">
                            <v-icon color="primary" class="mr-2"
                              >mdi-check-circle</v-icon
                            >
                            <span class="text-h6">Validation</span>
                          </div>

                          <div
                            v-for="(valid, indexValid) in items.listValidation"
                            :key="indexValid + 'Validate'"
                            class="mb-4"
                          >
                            <v-row>
                              <v-col sm="12" md="4">
                                <v-text-field
                                  label="Key"
                                  v-model="valid.key"
                                  variant="outlined"
                                  density="comfortable"
                                  hide-details
                                  color="primary"
                                ></v-text-field>
                              </v-col>
                              <v-col sm="12" md="3">
                                <v-autocomplete
                                  ref="model"
                                  label="Type Validate*"
                                  :items="DDTypeValidation"
                                  item-title="name"
                                  item-value="value"
                                  clearable
                                  variant="outlined"
                                  v-model="valid.typeValidation"
                                  density="comfortable"
                                  hide-details
                                  color="primary"
                                ></v-autocomplete>
                              </v-col>
                              <v-col
                                sm="12"
                                md="3"
                                v-if="valid.typeValidation == 'MCV'"
                              >
                                <v-text-field
                                  :id="
                                    'NumberOfCharacter-intentsessiondetail' +
                                    indexs
                                  "
                                  label="Number of Character"
                                  v-model="valid.numberOfCharacter"
                                  variant="outlined"
                                  density="comfortable"
                                  hide-details
                                  color="primary"
                                ></v-text-field>
                              </v-col>
                              <v-col
                                sm="12"
                                md="3"
                                v-if="valid.typeValidation == 'RV'"
                              >
                                <v-text-field
                                  :id="
                                    'ValidationRegularExpression-intentsessiondetail' +
                                    indexs
                                  "
                                  label="Regular Expression"
                                  v-model="valid.regExp"
                                  variant="outlined"
                                  density="comfortable"
                                  hide-details
                                  color="primary"
                                ></v-text-field>
                              </v-col>
                              <v-col sm="12" md="1" class="d-flex align-center">
                                <v-btn
                                  :id="
                                    'DeleteValidation-intentsessiondetail' +
                                    indexs
                                  "
                                  @click="
                                    DeleteValidation(items, indexs, indexValid)
                                  "
                                  icon
                                  size="small"
                                  variant="text"
                                  color="error"
                                >
                                  <v-icon>mdi-delete-circle</v-icon>
                                </v-btn>
                              </v-col>
                              <v-col cols="12">
                                <v-textarea
                                  variant="outlined"
                                  v-model="valid.promptMessage"
                                  label="Error Message"
                                  placeholder="Enter the validation error message..."
                                  hide-details="auto"
                                  color="primary"
                                ></v-textarea>
                              </v-col>
                            </v-row>
                          </div>

                          <v-btn
                            :id="'AddValidation-intentsessiondetail' + indexs"
                            @click="AddValidation(items)"
                            variant="outlined"
                            color="primary"
                            size="small"
                            class="mt-2"
                          >
                            <v-icon start>mdi-plus-circle</v-icon>
                            Add Validation
                          </v-btn>
                        </div>

                        <!-- Text Response Section for API -->
                        <div class="mb-4">
                          <div class="section-title-simple mb-3">
                            <v-icon color="primary" class="mr-2"
                              >mdi-message-text</v-icon
                            >
                            <span class="text-h6">Text Response</span>
                          </div>
                          <v-textarea
                            variant="outlined"
                            v-model="items.textResponse"
                            label="Response Message"
                            placeholder="Enter the response message..."
                            hide-details="auto"
                            color="primary"
                          ></v-textarea>
                        </div>
                      </div>
                    </v-expand-transition>

                    <!-- Interest Optimizer Content -->
                    <v-expand-transition>
                      <div v-show="items.actionType == 'IO'">
                        <v-card flat class="pa-4 interest-optimizer-section mb-6">
                          <div class="section-title-simple mb-4">
                            <v-icon color="primary" class="mr-2">mdi-calculator</v-icon>
                            <span class="text-h6">Interest Optimizer Configuration</span>
                          </div>

                          <!-- Answer Model Selection -->
                          <v-row class="mb-4">
                            <v-col cols="12" md="6">
                              <v-autocomplete
                                :id="'io-answer-model-' + indexs"
                                label="Model สำหรับตอบ (Answer Model)*"
                                :items="listDDModelDisplayName"
                                :item-title="getItemModelNameText"
                                item-value="modelDisplayID"
                                clearable
                                variant="outlined"
                                v-model="items.modelDisplayRouting"
                                density="comfortable"
                                hide-details="auto"
                                color="primary"
                              >
                                <template v-slot:append-inner>
                                  <v-tooltip location="top">
                                    <template v-slot:activator="{ props }">
                                      <v-icon
                                        v-bind="props"
                                        size="small"
                                        color="grey-darken-1"
                                      >
                                        mdi-information-outline
                                      </v-icon>
                                    </template>
                                    <span>Model ที่จะใช้ในการตอบคำถามผู้ใช้</span>
                                  </v-tooltip>
                                </template>
                              </v-autocomplete>
                            </v-col>
                            <v-col cols="6">
                              <v-autocomplete
                                :id="'io-parser-model-' + indexs"
                                label="Model แปลงคำถามเป็น JSON (Parser Model)*"
                                :items="listDDModelDisplayName"
                                :item-title="getItemModelNameText"
                                item-value="modelDisplayID"
                                clearable
                                variant="outlined"
                                v-model="items.modelJson"
                                density="comfortable"
                                hide-details="auto"
                                color="primary"
                              >
                                <template v-slot:append-inner>
                                  <v-tooltip location="top">
                                    <template v-slot:activator="{ props }">
                                      <v-icon
                                        v-bind="props"
                                        size="small"
                                        color="grey-darken-1"
                                      >
                                        mdi-information-outline
                                      </v-icon>
                                    </template>
                                    <span>Model ที่จะแปลงคำถามของผู้ใช้เป็น JSON parameter</span>
                                  </v-tooltip>
                                </template>
                              </v-autocomplete>
                            </v-col>
                          </v-row>

                          <!-- Account Code Selection (Multiple) -->
                          <v-row class="mb-4">
                            <v-col cols="12">
                              <v-autocomplete
                                :id="'io-account-codes-' + indexs"
                                label="Account Codes (เลือกได้มากกว่า 1 ค่า)*"
                                :items="interestMasterOptions"
                                item-title="name"
                                item-value="accountCode"
                                multiple
                                chips
                                clearable
                                variant="outlined"
                                v-model="items.accountCode"
                                density="comfortable"
                                hide-details="auto"
                                color="primary"
                                :loading="loadingInterestMaster"
                              >
                                <template v-slot:selection="{ item, index }">
                                  <v-chip
                                    v-if="index < 2"
                                    color="primary"
                                    variant="outlined"
                                    size="small"
                                    closable
                                    @click:close="removeAccountCode(items, item.value)"
                                  >
                                    {{ item.title }}
                                  </v-chip>
                                  <span
                                    v-if="index === 2"
                                    class="text-grey text-caption align-self-center"
                                  >
                                    (+{{ items.selectedAccountCodes.length - 2 }} others)
                                  </span>
                                </template>
                                <template v-slot:append-inner>
                                  <v-tooltip location="top">
                                    <template v-slot:activator="{ props }">
                                      <v-icon
                                        v-bind="props"
                                        size="small"
                                        color="grey-darken-1"
                                      >
                                        mdi-information-outline
                                      </v-icon>
                                    </template>
                                    <span>เลือก Account Code ที่ต้องการให้ระบบคำนวณ (สามารถเลือกได้หลายค่า)</span>
                                  </v-tooltip>
                                </template>
                              </v-autocomplete>
                            </v-col>
                          </v-row>
                        </v-card>
                      </div>
                    </v-expand-transition>
                  </div>

                  <v-btn
                    v-if="canAdd"
                    :id="'AddNewAction-intentsessiondetail'"
                    @click="AddNewAction()"
                    variant="outlined"
                    color="primary"
                    size="large"
                    block
                    class="add-action-btn"
                  >
                    <v-icon start>mdi-plus-circle</v-icon>
                    Add New Action
                  </v-btn>
                </div>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>

          <!-- Action Buttons -->
          <v-row class="mt-8">
            <v-col cols="12" class="d-flex justify-end">
              <v-btn
                :id="'button-close-intentsessiondetail'"
                @click="Back()"
                variant="outlined"
                color="warning"
                size="large"
                class="mr-4"
              >
                <v-icon start>mdi-close</v-icon>
                CLOSE
              </v-btn>
              <v-btn
                v-if="canAdd && AddEvent"
                :id="'button-saveadd-intentsessiondetail'"
                @click="SaveAdd()"
                variant="elevated"
                color="primary"
                size="large"
              >
                <v-icon start>mdi-content-save</v-icon>
                SAVE
              </v-btn>
              <v-btn
                v-else-if="canEdit"
                :id="'button-saveedit-intentsessiondetail'"
                @click="SaveEdit()"
                variant="elevated"
                color="primary"
                size="large"
              >
                <v-icon start>mdi-content-save</v-icon>
                SAVE
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-container>

    <!-- Loading Dialog -->
    <v-overlay :model-value="dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>

    <!-- Clipboard Popup -->
    <v-snackbar
      v-model="showClipboardPopup"
      timeout="2000"
      color="success"
      location="bottom left"
    >
      <v-icon start>mdi-check</v-icon>
      Copied to clipboard!
    </v-snackbar>
  </div>
</template>
<script>
import checkPermissionTwo from "@/api/function.js";
import { PrismEditor } from "vue-prism-editor";
import "vue-prism-editor/dist/prismeditor.min.css"; // import the styles
import { highlight, languages } from "prismjs";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/themes/prism-tomorrow.css";
import "prismjs/components/prism-rust";
import DragDropFile from "@/components/DragDropFile.vue";
import ExcelJS from "exceljs";

import "prismjs/plugins/line-numbers/prism-line-numbers.js";
import "prismjs/plugins/line-numbers/prism-line-numbers.css";
import { kccPickerSource } from "@/services/kccPickerSource";
export default {
  name: "IntentSessionDetail",
  inject: ["flagNav"],
  components: { PrismEditor, DragDropFile },
  mixins: [checkPermissionTwo],
  data: () => ({
    options: {},
    dataTable: [],
    VectorDetail: [],
    Selected: [],
    itemsPerPage: 10,
    searchTotalTable: 0,
    totalTable: 0,
    listDDModelDisplayName: [],
    listDDIntentGroup: [],
    Search: "",
    CodeEx: '{\n   "A":""\n}',
    id: null,
    panel: [0, 1],
    dialog: false,
    loadingTable: false,
    AddEvent: false,
    ShowTable: false,
    today: null,
    loading: true,
    DataCol: [],
    type: null,
    sortBy: [],
    sortDesc: [],
    isFirst: true,
    isSearch: false,
    showClipboardPopup: false,
    rules: {
      required: (value) => !!value || "Required.",
    },
    Intent: [{ text: "What was that?" }, { text: "" }],
    VectorName: "",
    Vectors: "",
    Request: {
      IntentGroupID: 0,
      IntentSessionID: 0,
      IntentActionID: 0,
      Score: "",
      Name: "",
      UseMemory: false,
      PromptSession:
        "Find the Intent from the message of users.\n#Condition for Response\n1. If the user asks a question related to or similar in meaning to the #Group Intent below. You must response 1. Otherwise, 0\n#Group Intent\n",
      ActionType: "",
      TBLVector: "",
      Intent: "",
      Prompt: "",
      IntentActions: [],
    },
    RequestIntentAction: {
      intentActionID: 0,
      tblVector: "",
      prompt: "",
      textResponse: "",
      method: "",
      apiEndpoint: "",
      listHeadersAPITrigger: [
        {
          key: "",
          value: "",
        },
      ],
      jsonValidate: '{\n   "A":""\n}',
      modelDisplayRouting: null,
      listValidation: [
        {
          key: "",
          typeValidation: "",
          numberOfCharacter: "",
          regExp: "",
          promptMessage: "",
        },
      ],
      nextRouting: null,
      isMergePrompt: true,
      actionType: "",
      isActionAnswer: false,
      activeFlag: true,
      botDisableTime: null,
    },
    DataRowUpload: [],
    DDActionType: [
      {
        name: "Vector",
        value: "VT",
      },
      {
        name: "Text Response",
        value: "TR",
      },
      {
        name: "Model Routing",
        value: "MR",
      },
      {
        name: "Next Routing",
        value: "NR",
      },
      {
        name: "Contact Agent (Disable Bot)",
        value: "CA",
      },
      {
        name: "API Trigger",
        value: "AT",
      },
      {
        name: "Interest Optimizer",
        value: "IO",
        chip: "Feature LHB"
      },
    ],
    DDTypeValidation: [
      {
        name: "Validation Phone",
        value: "PV",
      },
      {
        name: "Validation Email",
        value: "EV",
      },
      {
        name: "Validation Max Character",
        value: "MCV",
      },
      {
        name: "Validation Regular Expression",
        value: "RV",
      },
    ],
    DDMethod: ["GET", "POST", "PUT", "DELETE"],
    DDVector: [],
    // App Knowledge Center (kccPickerSource): kccCenterMode = status.enabled ⇒ DDVector = เอกสารของ Center เท่านั้น
    // และ action VT (เลือก chunk จาก tblvector ของ Genie) ใช้ไม่ได้ (D4)
    kccCenterMode: false,
    uploadedFiles: [],
    entity: null,
    // Interest Optimizer data
    interestMasterOptions: [], // Will be loaded from API
    loadingInterestMaster: false,
  }),
  computed: {
    isViewOnly() {
      return this.$pagePermission && this.$pagePermission.isViewOnly('IntentSessionDetail');
    },
    canAdd() {
      return !!(this.$pagePermission && this.$pagePermission.canAdd('IntentSessionDetail'));
    },
    canEdit() {
      return !!(this.$pagePermission && this.$pagePermission.canEdit('IntentSessionDetail'));
    },
    canDelete() {
      return !!(this.$pagePermission && this.$pagePermission.canDelete('IntentSessionDetail'));
    },
    headers() {
      return [
        {
          text: "",
          align: "center",
          justify: "center",
          sortable: false,
          width: "10px",
        },
        {
          text: "text_org",
          value: "TextORG",
          align: "center",
          sortable: true,
          width: "50%",
        },
        {
          text: "text_en",
          value: "TextEN",
          align: "center",
          sortable: true,
          width: "50%",
        },
      ];
    },
  },
  watch: {
    options: {
      handler() {
        this.GetByVector();
      },
      deep: true,
    },
  },
  methods: {
    showPopup() {
      this.showClipboardPopup = true;
      setTimeout(() => {
        this.showClipboardPopup = false;
      }, 2000);
    },
    CopyText(text) {
      navigator.clipboard.writeText(text);
      this.showPopup();
    },

    onDragStart(event, text) {
      event.dataTransfer.setData("text/plain", text);
      event.dataTransfer.effectAllowed = "copy";
    },

    onDragOver(event) {
      // event.preventDefault();
      event.dataTransfer.dropEffect = "copy";

      // เพิ่ม visual feedback
      const editor = event.target.closest(".prism-editor-wrapper");
      if (editor) {
        editor.classList.add("drag-over");
      }
    },

    onDragLeave(event) {
      // เอา visual feedback ออก
      const editor = event.target.closest(".prism-editor-wrapper");
      if (editor) {
        editor.classList.remove("drag-over");
      }
    },

    onDrop(event) {
      event.preventDefault();
      const text = event.dataTransfer.getData("text/plain");

      // หา prism-editor element
      const editor = event.target.closest(".prism-editor-wrapper");
      const textarea = editor?.querySelector("textarea");

      if (textarea) {
        // เอา visual feedback ออก
        editor.classList.remove("drag-over");

        // คำนวณตำแหน่งจาก mouse position
        const rect = textarea.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;

        // หาตำแหน่งใน textarea จากพิกัด mouse
        let position = 0;

        // ใช้ caretPositionFromPoint หรือ caretRangeFromPoint
        if (document.caretPositionFromPoint) {
          const caretPos = document.caretPositionFromPoint(
            event.clientX,
            event.clientY
          );
          if (caretPos && caretPos.offsetNode === textarea) {
            position = caretPos.offset;
          }
        } else if (document.caretRangeFromPoint) {
          const range = document.caretRangeFromPoint(
            event.clientX,
            event.clientY
          );
          if (range && range.startContainer === textarea) {
            position = range.startOffset;
          }
        } else {
          // Fallback: คำนวณตำแหน่งโดยประมาณ
          const lines = textarea.value.split("\n");
          const lineHeight =
            parseInt(getComputedStyle(textarea).lineHeight) || 20;
          const charWidth = 8; // ความกว้างโดยประมาณของตัวอักษร

          const lineIndex = Math.floor(y / lineHeight);
          const charIndex = Math.floor(x / charWidth);

          if (lineIndex < lines.length) {
            position = lines.slice(0, lineIndex).join("\n").length;
            if (lineIndex > 0) position += 1; // เพิ่ม newline
            position += Math.min(charIndex, lines[lineIndex]?.length || 0);
          } else {
            position = textarea.value.length;
          }
        }

        // แทรกข้อความที่ตำแหน่งที่คำนวณได้
        const currentValue = textarea.value;
        const newValue =
          currentValue.substring(0, position) +
          text +
          currentValue.substring(position);

        // หา action item ที่ตรงกัน และอัพเดต
        const editorId = editor.closest('[id^="codeEditor"]')?.id;
        if (editorId) {
          const indexMatch = editorId.match(/codeEditor-(\d+)/);
          if (indexMatch) {
            const actionIndex = parseInt(indexMatch[1]);
            const actions = this.Request.IntentActions.filter(
              (e) => e.activeFlag === true
            );
            if (actions[actionIndex]) {
              actions[actionIndex].jsonValidate = newValue;

              // ตั้งตำแหน่ง cursor หลังข้อความที่แทรก
              this.$nextTick(() => {
                const newPosition = position + text.length;
                textarea.setSelectionRange(newPosition, newPosition);
                textarea.focus();
              });
            }
          }
        }
      }
    },

    // ปรับปรุง insertVariable method
    insertVariable(text, indexs) {
      const editorId = `codeEditor-${indexs}`;
      const editor = document.getElementById(editorId);
      const textarea = editor?.querySelector("textarea");

      if (textarea) {
        const start = textarea.selectionStart || 0;
        const end = textarea.selectionEnd || 0;
        const currentValue = textarea.value;

        const newValue =
          currentValue.substring(0, start) + text + currentValue.substring(end);

        // อัพเดต model
        const actions = this.Request.IntentActions.filter(
          (e) => e.activeFlag === true
        );
        if (actions[indexs]) {
          actions[indexs].jsonValidate = newValue;
        }

        // ตั้งตำแหน่ง cursor
        this.$nextTick(() => {
          textarea.setSelectionRange(start + text.length, start + text.length);
          textarea.focus();
        });
      }
    },
    ChangeAction(IntentAction) {
      IntentAction.tblVector = "";
      IntentAction.prompt = "";
      IntentAction.textResponse = "";
      IntentAction.method = "";
      IntentAction.apiEndpoint = "";
      IntentAction.listHeadersAPITrigger = [
        {
          key: "",
          value: "",
        },
      ];
      IntentAction.listValidation = [
        {
          key: "",
          typeValidation: "",
          numberOfCharacter: "",
          regExp: "",
          promptMessage: "",
        },
      ];
      IntentAction.jsonValidate = '{\n   "A":""\n}';
      IntentAction.modelDisplayRouting = null;
      IntentAction.modelJson = null;
      IntentAction.accountCode = [];
      IntentAction.nextRouting = null;
      IntentAction.isMergePrompt = IntentAction.actionType != "AT";
      IntentAction.botDisableTime = "";
      
      // Initialize IO fields if actionType is IO
      if (IntentAction.actionType === 'IO') {
        this.initializeIOFields(IntentAction);
      }
    },
    AddNewAction() {
      this.Request.IntentActions.push({
        intentActionID: "",
        tblVector: "",
        prompt: "",
        textResponse: "",
        method: "",
        apiEndpoint: "",
        listHeadersAPITrigger: [
          {
            key: "",
            value: "",
          },
        ],
        listValidation: [
          {
            key: "",
            typeValidation: "",
            numberOfCharacter: "",
            regExp: "",
            promptMessage: "",
          },
        ],
        jsonValidate: '{\n   "A":""\n}',
        modelDisplayRouting: null,
        nextRouting: null,
        isMergePrompt: this.Request.IntentActions.length == 0,
        actionType: "",
        isActionAnswer: this.Request.IntentActions.length == 0,
        accountCode: [],
        modelJson: null,
        activeFlag: true,
        vectorDetail: [],
        contactAgent: "",
        botDisableTime: "",
      });
    },
    AddHeader(item) {
      item.listHeadersAPITrigger.push({
        key: "",
        value: "",
      });
    },
    AddValidation(item) {
      item.listValidation.push({
        key: "",
        typeValidation: "",
        numberOfCharacter: "",
        regExp: "",
        promptMessage: "",
      });
    },
    DeleteAction(item, index) {
      item.activeFlag = false;
      if (item.intentActionID == 0) {
        this.Request.IntentActions.splice(index, 1);
      }
    },
    DeleteHeader(item, index, indexHeader) {
      if (item.listHeadersAPITrigger.length > 0) {
        this.Request.IntentActions[index].listHeadersAPITrigger.splice(
          indexHeader,
          1
        );
      }
    },
    DeleteValidation(item, index, indexValidation) {
      if (item.listValidation.length > 0) {
        this.Request.IntentActions[index].listValidation.splice(
          indexValidation,
          1
        );
      }
    },
    highlighter(code) {
      // ตรวจสอบว่าใช้ syntax นี้
      return highlight(code, languages.js);
    },
    formatText(text) {
      if (text === null || text === undefined) {
        return '';
      }
      return String(text).replace(/ /g, "&nbsp;");
    },
    DeleteVectorByBtn(IntentAction, Id) {
      let self = this;
      // self.Selected.splice(self.Selected.indexOf(Id), 1);
      // IntentAction.vectorDetail.splice(
      //   IntentAction.vectorDetail.findIndex((e) => e.tblVector == Id),
      //   1
      // );
      // IntentAction.tblVector = self.Selected.join(",");
      // console.log("Selected", self.Selected);
      // self.dataTable.forEach((element) => {
      //   element.selected = false;
      //   var chk = self.Selected.find((e) => e == element.id);
      //   if (chk != undefined) {
      //     element.selected = true;
      //   }
      // });

      if (self.Selected && Array.isArray(self.Selected[0])) {
        self.Selected[0] = self.Selected[0].filter((e) => e !== Id);
      }
      IntentAction.tblVector = self.Selected.join(",");
      self.dataTable.forEach((element) => {
        element.selected = false;
        var chk = self.Selected.find((e) => e == element.id);
        if (chk != undefined) {
          element.selected = true;
        }
      });
    },
    SelectVector(IntentAction, Flag, Id, TextORG) {
      let self = this;
      if (Flag) {
        self.Selected.push(Id);
        IntentAction.tblVector = self.Selected.join(",");
        if (IntentAction.vectorDetail != null) {
          IntentAction.vectorDetail.push({ textORG: TextORG, tblVector: Id });
        } else {
          IntentAction.vectorDetail = [{ textORG: TextORG, tblVector: Id }];
        }
      } else {
        if (self.Selected.indexOf(Id) > -1) {
          // Check if Id exists in Selected
          self.Selected.splice(self.Selected.indexOf(Id), 1);
          IntentAction.vectorDetail.splice(
            IntentAction.vectorDetail.findIndex((e) => e.tblVector == Id),
            1
          );
          IntentAction.tblVector = self.Selected.join(',');
        }
      }
    },

    // Interest Optimizer Methods
    initializeIOFields(item) {
      // Initialize Interest Optimizer fields when action type changes to IO
      if (!item.ioAnswerModel) item.ioAnswerModel = null;
      if (!item.ioMasterId) item.ioMasterId = null;
      if (!item.ioParserModel) item.ioParserModel = null;
    },

    CheckNewIntent(index) {
      let self = this;
      if (self.Intent.length == index + 1) {
        self.Intent.push({ text: "" });
      }
      return true;
    },
    CheckDeleteIntent(index, value) {
      let self = this;

      self.$nextTick(() => {
        const textareas = self.$refs.textareas;
        if (value == "" && index > 0 && self.Intent.length > 1) {
          self.Intent.splice(index, 1);
          if (textareas[index - 1]) {
            textareas[index - 1].focus();
          }
        }
        if (
          value == "" &&
          index <= self.Intent.length - 1 &&
          self.Intent.length > 1
        ) {
          self.Intent.splice(index, 1);
          if (textareas[index]) {
            textareas[index].focus();
          }
        }
      });
    },
    newLineEnter(index) {
      let self = this;
      if (self.Intent.length >= index + 1) {
        self.Intent.push({ text: "" });
      }
      //cursor
      self.$nextTick(() => {
        const textareas = self.$refs.textareas;
        if (textareas[index + 1]) {
          textareas[index + 1].focus();
        }
      });
    },
    DeleteIntent(index) {
      let self = this;
      if (self.Intent.length > 1) {
        self.Intent.splice(index, 1);
      }
    },
    onPaste(index, event) {
      let self = this;
      // event.preventDefault();
      const paste = event.clipboardData.getData("text");
      self.$set(self.Intent, index, { text: paste });
      if (self.Intent.length == index + 1) {
        self.Intent.push({ text: "" });
      }
    },
    getItemModelNameText(item) {
      return `${item.modelDisplayID}: ${item.name}`;
    },
    async GetModel() {
      let self = this;
      await self.$call.DDGPTModel(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.listDDModelDisplayName = dataResponse.data;
          } else {
            self.listDDModelDisplayName = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    async Get() {

      let self = this;
      self.dialog = true;
      self.$call.GetIntentSessionDetailById(
        self.id,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.dialog = false;
            self.Binding(dataResponse.data);
            
          }
          self.GetModel();
          self.GetDDVectorName();
          self.GetIntentGroup();
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    GetByVector() {
      let self = this;
      if (self.VectorName == "" || self.VectorName == null) {
        return;
      }
      // App Knowledge Center (D4): โหมด Center ไม่อ่าน chunk จาก tblvector ของ Genie (VT ใช้ไม่ได้)
      if (self.kccCenterMode) {
        return;
      }
      self.dialog = true;
      self.loadingTable = true;

      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === "desc";
      }
      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        name: self.VectorName,
        sortDesc: sortOrder,
        sortBy: sortField,
      };
      self.$call.GetTableVector(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.table.total;
            self.dataTable = dataResponse.data.table.data;
            self.totalTable = dataResponse.data.table.total;
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.loadingTable = false;
          self.isSearch = false;
          self.isFirst = false;
          self.ShowTable = true;
          self.dialog = false;
          self.dataTable.forEach((element) => {
            element.show = self.ShowAllText;
            element.selected = false;
            for (let index = 0; index < self.Selected.length; index++) {
              const element2 = self.Selected.find(
                (e) => e == element.id
              );
              if (element2 != undefined) {
                element.selected = true;
              }
            }
          });
        },
        (errorResource) => {
          self.dialog = false;
          self.loadingTable = false;
          self.isSearch2 = false;
          console.error(errorResource);
        }
      );
    },
    async loadAccountInfoDropdown() {
      let self = this;
      self.loadingInterestMaster = true;
      await self.$call.GetAccountInfoDropdownOptions(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.interestMasterOptions = dataResponse.data;
          } else {
            self.interestMasterOptions = [];
          }
          self.loadingInterestMaster = false;
        },
        (errorResource) => {
          self.loadingInterestMaster = false;
          console.error('Error loading AccountInfo dropdown:', errorResource);
          self.$swal.fire({
            icon: 'error',
            title: 'ข้อผิดพลาด',
            text: 'ไม่สามารถโหลดข้อมูล Account Code ได้',
          });
        }
      );
    },
    SaveAdd() {
      let self = this;
      if (self.validate()) {
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warningFillAll"),
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      this.Prepare();
      
      try {
        self.dialog = true;
        self.$call.CreateIntentSession(
          self.Request,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.$swal.fire({
                icon: "success",
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });
              self.$router.push({
                name: "IntentSession",
                query: {
                  id: self.Request.IntentGroupID,
                },
              });
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        console.log("catch : AddIntentSession");
      }
    },
    SaveEdit() {
      let self = this;
      if (self.validate()) {
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warningFillAll"),
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      this.Prepare();
      try {
        self.dialog = true;
        self.$call.UpdateIntentSession(
          self.Request,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.$swal.fire({
                icon: "success",
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });
              self.$router.push({
                name: "IntentSession",
                query: {
                  id: self.Request.IntentGroupID,
                },
              });
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        console.log("catch : UpdateIntentSession");
      }
    },
    Back() {
      this.$router.push({
        name: "IntentSession",
        query: {
          id: this.Request.IntentGroupID,
        },
      });
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    async GetIntentGroup() {
      let self = this;
      self.dialog = true;
      await self.$call.DDIntentGroup(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            self.listDDIntentGroup = dataResponse.data;
          } else {
            self.listDDIntentGroup = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    // App Knowledge Center (TASK 2026-10-28 G10 · AC-9 · A4/D4): true = โหมด Center (DDVector = catalog ของ Runtime key,
    // อาจว่าง — ไม่ถอยไปของในเครื่อง; picker VT ถูกปิดอยู่แล้ว) · false = โหมดปิด (ใช้ $call เดิม) · kccPickerSource ไม่ throw
    async kccApplyVectorList() {
      let list = null;
      try {
        list = await kccPickerSource.vectorList();
      } catch (e) {
        list = null;
      }
      this.kccCenterMode = list !== null;
      if (list === null) {
        return false;
      }
      this.DDVector = list;
      return true;
    },
    async GetDDVectorName() {
      let self = this;
      self.dialog = true;
      if (await self.kccApplyVectorList()) {
        self.dialog = false;
        return;
      }
      await self.$call.GetDDVectorDBName(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDVector = dataResponse.data;
          } else {
            self.DDVector = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    validate() {
      let self = this;
      if (
        self.Request.Name == "" ||
        self.Request.Name == null ||
        self.Request.PromptSession == "" ||
        self.Request.PromptSession == null ||
        self.Request.IntentActions == null ||
        self.Request.IntentActions.length == 0 ||
        self.validateAction()
      ) {
        return true;
      }
      self.Request.Score = self.Request.Score == "" ? null : self.Request.Score;
      return false;
    },
    validateAction() {
      let self = this;

      if (
        !self.Request.IntentActions ||
        !Array.isArray(self.Request.IntentActions)
      ) {
        return true;
      }
      let check = self.Request.IntentActions.filter(
        (e) => e.activeFlag == true
      );
      return check.some((action) => {
        return (
          (action.actionType == "VT" &&
            (action.tblVector == "" || action.tblVector == null)) ||
          (action.actionType == "TR" &&
            (action.textResponse == "" || action.textResponse == null)) ||
          (action.actionType == "MR" &&
            (action.modelDisplayRouting == "" ||
              action.modelDisplayRouting == null)) ||
          (action.actionType == "NR" &&
            (action.nextRouting == "" || action.nextRouting == null)) ||
          (action.actionType == "CA" &&
            (action.contactAgent == "" || action.contactAgent == null))
        );
      });
    },
    Prepare() {
      let self = this;
      self.Request.Intent = self.Intent.filter((e) => e.text !== "")
        .map((e) => e.text)
        .join(",");

      self.Request.IntentActions.forEach(action => {
        if (action.botDisableTime === "" || action.botDisableTime === null) {
          action.botDisableTime = null;
        } else {
          action.botDisableTime = parseInt(action.botDisableTime) || null;
      }
  });
    },
    Binding(Source) {
      let self = this;
      if (Source != null) {
        let intentArray = Source.intent.split(",");
        self.Intent = intentArray.map((intent) => ({ text: intent }));
        self.Intent.push({ text: "" });
        self.Request.Name = Source.name;
        self.Request.Score = Source.score;
        self.Request.UseMemory = Source.useMemory;
        self.Request.PromptSession = Source.promptSession;
        if (Source.intentAction.length > 0) {
          // self.Request.ActionType = Source.intentAction[0].actionType;
          // self.Request.Prompt = Source.intentAction[0].prompt;
          // self.Request.TextResponse = Source.intentAction[0].textResponse;
          // self.Request.ModelRouting = Source.intentAction[0].modelDisplayRouting;
          // self.Request.NextRouting = Source.intentAction[0].nextIntentGroupID;
          // self.Request.TBLVector = Source.intentAction[0].tblVector;
          // self.Request.IntentActionID = Source.intentAction[0].intentActionID;
          // self.Request.IsMergePrompt = Source.intentAction[0].isMergePrompt ?? false;
          // self.VectorDetail = Source.intentAction[0].vectorDetail ?? [];
          self.Request.IntentActions = Source.intentAction;
          // self.Request.IntentActions.ListHeadersAPITrigger = Source.intentAction
          self.Request.IntentActions.forEach((element, index) => {
            if (element.actionType == "VT") {
              self.Selected[index] = element.tblVector.split(",").map(Number);
            }
          });
        }
      }
    },
    isNumber: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46 &&
        charCode !== 45
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isNumberpositive: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isEnter: function (evt, index) {
      let self = this;
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode === 13) {
        evt.preventDefault();
      } else {
        self.CheckNewIntent(index);
        return true;
      }
    },
    downloadTemplate() {
      // สร้าง workbook และ worksheet ใหม่
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Template");

      // เพิ่มข้อมูลลงในเวิร์กชีต
      worksheet.addRow(["Intent text"]);
      worksheet.addRow(["หมีเนยคือใคร?"]);
      worksheet.addRow(["หมีเนยอายุเท่าไหร่?"]);
      worksheet.addRow(["สถานะภาพของหมีเนยคือ?"]);

      // ดาวน์โหลดไฟล์
      workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "intent_text_template.xlsx";
        a.click();
        window.URL.revokeObjectURL(url);
      });
    },
    processUpload(event) {
      let self = this;
      self.files = event;
      if (self.files.length === 0) {
        self.uploadedFiles = [];
        return;
      }

      const reader = new FileReader();
      const file = self.files[0];
      reader.onload = async (e) => {
        const workbook = new ExcelJS.Workbook();
        try {
          const buffer = e.target.result;
          await workbook.xlsx.load(buffer);

          // อ่านข้อมูลจาก worksheet แรก
          const worksheet = workbook.worksheets[0];
          const jsonData = [];

          // แปลงข้อมูลจาก worksheet เป็น array 2 มิติ
          worksheet.eachRow((row, rowNumber) => {
            const rowData = [];
            row.eachCell((cell) => {
              rowData.push(cell.value);
            });
            jsonData.push(rowData);
          });

          // ข้ามแถวแรกที่เป็นหัวข้อ
          self.DataRowUpload = jsonData.slice(1);
          self.ValidateFile(self.files);
          self.ConfirmProcess();
        } catch (error) {
          console.error("Error reading Excel file:", error);
          self.$swal.fire({
            icon: "error",
            title: "Error reading Excel file",
            text: "The file format is not supported or the file is corrupted.",
          });
        }
      };
      reader.readAsArrayBuffer(file);
    },
    ValidateFile(files) {
      const formDataDoc = new FormData();
      formDataDoc.append("upload_file", files[0]);
      self.uploadedFiles = files;
      self.entity = formDataDoc;
    },
    ConfirmProcess() {
      let self = this;
      self.$swal
        .fire({
          title: this.$t("importIntentText"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("yes"),
          cancelButtonText: this.$t("cancel"),
        })
        .then((result) => {
          if (result.isConfirmed) {
            const newData = self.DataRowUpload.map((row) => {
              return { text: row.join(" ") };
            });

            if (self.Intent.length > 0) {
              self.Intent = self.Intent.filter(
                (item) => item.text.trim() !== ""
              );
              // ถ้ามีข้อมูลอยู่แล้ว ให้ต่อข้อมูลใหม่เข้าไปใน Intent เดิม
              self.Intent = [...self.Intent, ...newData];
            } else {
              self.Intent = newData;
            }
          }
        });
    },
  },
  async mounted() {
    let self = this;
    self.GetDate();
    
    // Load AccountInfo dropdown options
    await self.loadAccountInfoDropdown();
    
    if (self.$route.query.id) {
      self.id = self.$route.query.id;
      self.Request.IntentSessionID = self.$route.query.id;
      self.Request.IntentGroupID = self.$route.query.idGroup;
      await self.Get();
    } else if (self.$route.query.idGroup) {
      self.Request.IntentGroupID = self.$route.query.idGroup;
      self.AddEvent = true;
      await self.GetModel();
      await self.GetDDVectorName();
      await self.GetIntentGroup();
    }
    self.AddNewAction();
  },
};
</script>
<style scoped>

/* .card2 {
  border-radius: 0 0 16px 16px !important;
  margin-bottom: 2rem;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.header-title {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%) !important;
  border-radius: 16px 16px 0 0 !important;
} */
 
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
}

/* Modern Expansion Panels */
.modern-panel {
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
  border-radius: 12px !important;
  margin-bottom: 16px !important;
  overflow: hidden;
}

.panel-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%) !important;
  font-weight: 600 !important;
  padding: 16px 24px !important;
}

.header-text {
  font-size: 1.1rem;
  font-weight: 600;
  color: #1976d2;
}

.panel-content {
  padding: 24px !important;
}

.transition-transform {
  transition: transform 0.3s ease;
}

.rotate-180 {
  transform: rotate(180deg);
}

/* Intent Container */
.intent-container {
  border-radius: 12px !important;
  overflow: hidden;
}

.intent-item {
  display: flex;
  align-items: flex-start;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  transition: background-color 0.2s ease;
}

.intent-item:hover {
  background-color: rgba(25, 118, 210, 0.02);
}

.intent-item:hover .delete-intent-btn {
  opacity: 1;
}

.intent-number {
  background: linear-gradient(135deg, #f5f5f5 0%, #eeeeee 100%);
  padding: 16px 20px;
  font-weight: 600;
  color: #666;
  min-width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.intent-textarea {
  flex: 1;
  padding: 8px 16px;
}

.delete-intent-btn {
  opacity: 0;
  transition: opacity 0.2s ease;
  margin: 8px;
}

/* Action Cards */

.action-container {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
}

.action-section {
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  padding: 20px;
  background: white;
  position: relative;
  width: 100%;
}

.action-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.action-type-badge {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: 500;
  font-size: 0.875rem;
}

.action-type-badge.action-answer {
  background: linear-gradient(135deg, #9c27b0 0%, #7b1fa2 100%);
  color: white;
}

.action-type-badge.action-parallel {
  background: rgba(25, 118, 210, 0.1);
  color: #1976d2;
  border: 1px solid rgba(25, 118, 210, 0.3);
}

.action-type-text {
  font-weight: 600;
}

.delete-action-btn {
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.delete-action-btn:hover {
  opacity: 1;
}

/* Section Titles */
.section-title-simple {
  display: flex;
  align-items: center;
  padding-bottom: 8px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1);
}

.section-title-simple .text-h6 {
  color: #1976d2;
  font-weight: 600;
}

/* Selected Vector Chips */
.selected-vectors {
  background: rgba(25, 118, 210, 0.04);
  border-radius: 8px;
  padding: 12px;
  border: 1px solid rgba(25, 118, 210, 0.1);
}

.selected-vector-chip {
  margin: 2px !important;
  font-weight: 500 !important;
}

/* Vector Table */
.vector-table {
  border-radius: 8px !important;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

/* JSON Editor */
.json-editor-container {
  background: white;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.json-variables {
  background: #f8f9fa;
  padding: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.variables-header {
  margin-bottom: 8px;
  font-weight: 600;
  color: #666;
}

.variables-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.variable-chip {
  cursor: grab !important;
  transition: all 0.2s ease !important;
  user-select: none;
  position: relative;
}
.variable-chip:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
}

.modern-editor {
  background: #2d2d2d;
  color: #ccc;
  font-family: "Fira Code", "Fira Mono", Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  min-height: 200px;
}

/* Add Action Button */
.add-action-btn {
  border: 2px dashed #1976d2 !important;
  background: rgba(25, 118, 210, 0.02) !important;
  border-radius: 12px !important;
  padding: 16px !important;
  transition: all 0.3s ease !important;
  width: 80px !important;
}

.add-action-btn:hover {
  background: rgba(25, 118, 210, 0.08) !important;
  transform: translateY(-2px);
}

.action-card-wrapper {
  position: relative;
}

.action-card {
  border-radius: 16px !important;
  transition: all 0.3s ease;
  border: 2px solid transparent !important;
}

.action-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
}

.action-answer {
  background: linear-gradient(135deg, #9c27b0 0%, #7b1fa2 100%) !important;
  border-color: #9c27b0 !important;
}

.action-answer .action-title {
  color: white !important;
}

.action-parallel {
  background: white !important;
  border-color: #e0e0e0 !important;
}

.action-parallel .action-title {
  color: #1976d2 !important;
}

.action-title {
  padding: 20px 24px !important;
  border-radius: 16px 16px 0 0 !important;
  display: flex;
  align-items: center;
  font-weight: 600 !important;
  font-size: 1.1rem !important;
}

/* Vector Table */
.vector-table {
  border-radius: 12px !important;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.text-container {
  display: flex;
  align-items: flex-start;
  max-width: 100%;
}

.text-content {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  flex-grow: 1;
  line-height: 1.4;
}

.text-content-show {
  white-space: normal;
  flex-grow: 1;
  line-height: 1.4;
}

/* Selected Vector Chips */
.selected-vectors {
  background: rgba(25, 118, 210, 0.04);
  border-radius: 12px;
  padding: 16px;
}

.selected-vector-chip {
  margin: 4px !important;
  font-weight: 500 !important;
}

/* API Sections */
.api-section {
  background: rgba(248, 249, 250, 0.5);
  border-radius: 12px;
  padding: 20px;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.section-title {
  font-weight: 600;
  font-size: 1rem;
  color: #1976d2;
}

.header-row,
.validation-row {
  background: white;
  border-radius: 8px;
  padding: 12px;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

/* JSON Editor */
.json-editor-container {
  background: white;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.json-variables {
  background: #f8f9fa;
  padding: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.variables-header {
  margin-bottom: 12px;
  font-weight: 600;
  color: #666;
}

.variables-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.variable-chip {
  cursor: pointer !important;
  transition: all 0.2s ease !important;
}

.variable-chip:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;
}

.modern-editor {
  background: #2d2d2d;
  color: #ccc;
  font-family: "Fira Code", "Fira Mono", Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  min-height: 200px;
}

/* Action Buttons */
.add-action-btn {
  border: 2px dashed #1976d2 !important;
  background: rgba(25, 118, 210, 0.02) !important;
  border-radius: 12px !important;
  padding: 16px !important;
  transition: all 0.3s ease !important;
}

.add-action-btn:hover {
  background: rgba(25, 118, 210, 0.08) !important;
  transform: translateY(-2px);
}

/* Form Controls */
:deep(.v-field) {
  border-radius: 8px !important;
}

:deep(.v-field--outlined) {
  border: 1.5px solid rgba(0, 0, 0, 0.12) !important;
}

:deep(.v-field--focused) {
  border-color: #1976d2 !important;
}

:deep(.v-input--density-comfortable) {
  --v-input-control-height: 48px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .panel-content {
    padding: 16px !important;
  }

  .action-title {
    padding: 16px !important;
    font-size: 1rem !important;
  }
  .action-section {
    padding: 16px;
  }

  .action-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .api-section {
    padding: 16px;
  }

  .variables-grid {
    flex-direction: column;
    gap: 4px;
  }

  .variable-chip {
    width: 100%;
    justify-content: center;
  }

  .modern-editor:deep(.prism-editor-wrapper.drag-over::before) {
    font-size: 10px;
    padding: 6px 12px;
  }
}

/* Animation for smooth transitions */
.v-enter-active,
.v-leave-active {
  transition: all 0.3s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* Upload File Styling */
:deep(.UploadFile .NoDragDrop button.v-btn) {
  margin: 0px !important;
  border-radius: 8px !important;
}

@keyframes dragPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(25, 118, 210, 0.4);
  }
  70% {
    box-shadow: 0 0 0 8px rgba(25, 118, 210, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(25, 118, 210, 0);
  }
}

.variable-chip[draggable="true"]:hover {
  animation: dragPulse 1.5s infinite;
}
.variable-chip {
  cursor: grab !important;
  transition: all 0.2s ease !important;
  user-select: none;
}

.variable-chip:active {
  cursor: grabbing !important;
  transform: scale(0.95) !important;
}

.variable-chip:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2) !important;
}

.modern-editor {
  background: #2d2d2d;
  color: #ccc;
  font-family: "Fira Code", "Fira Mono", Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  min-height: 200px;
  position: relative;
  transition: all 0.2s ease;
}

/* Drop zone styling */
.modern-editor:deep(.prism-editor-wrapper) {
  border: 2px solid transparent;
  transition: all 0.2s ease;
  position: relative;
}

.modern-editor:deep(.prism-editor-wrapper.drag-over) {
  border-color: #1976d2;
  background-color: rgba(25, 118, 210, 0.08);
  box-shadow: 0 0 0 4px rgba(25, 118, 210, 0.1);
}

.modern-editor:deep(.prism-editor-wrapper.drag-over::before) {
  content: "Drop variable here";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(25, 118, 210, 0.9);
  color: white;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 12px;
  z-index: 10;
  pointer-events: none;
}
/* Variables grid improvements */
.variables-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px 0;
}

.variables-header {
  margin-bottom: 12px;
  font-weight: 600;
  color: #666;
  font-size: 0.875rem;
}
.time-field-container {
  max-width: 300px;
}

.time-unit {
  font-size: 0.875rem;
  font-weight: 500;
}

.info-icon {
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.info-icon:hover {
  opacity: 1;
}


/* Selected Vector Chips */
.selected-vector-chip {
  margin: 4px !important;
  font-weight: 500 !important;
  display: inline-flex !important;
  align-items: center !important;
  max-width: 200px !important;
}

.selected-vector-chip .chip-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}

/* ปรับแต่ง chip ให้แสดงปุ่ม close อย่างถูกต้อง */
.selected-vector-chip :deep(.v-chip__content) {
  display: flex !important;
  align-items: center !important;
  max-width: 100% !important;
  overflow: hidden !important;
}

.selected-vector-chip :deep(.v-chip__close) {
  flex-shrink: 0 !important;
  margin-left: 4px !important;
  order: 2 !important;
}

/* ปรับให้ข้อความไม่ไปทับปุ่ม close */
.selected-vector-chip :deep(.v-chip__content > span) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
}
</style>
